import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {OrderLine} from "../api";

export class OrderLineService extends RestService<OrderLine> {
    constructor(url: string) {
        if (url) {
            super(url)
        } else {
            super(REST_API_END_POINTS.ORDER_LINES)
        }
    }
}
